var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-container"
  }, [_c("el-select", {
    staticClass: "filter-item",
    attrs: {
      clearable: "",
      filterable: "",
      placeholder: "Select Role"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.dealersRoleId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "dealersRoleId", $$v);
      },
      expression: "listQuery.dealersRoleId"
    }
  }, _vm._l(_vm.roleList, function (role) {
    return _c("el-option", {
      key: role.id,
      attrs: {
        label: role.name,
        value: role.id
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      placeholder: "Search Product",
      clearable: "",
      remote: "",
      disabled: !_vm.listQuery.dealersRoleId,
      "reserve-keyword": "",
      "remote-method": _vm.fetchProductList
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.productId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "productId", $$v);
      },
      expression: "listQuery.productId"
    }
  }, _vm._l(_vm.productList, function (product) {
    return _c("el-option", {
      key: product.id,
      attrs: {
        label: product.name,
        value: product.id
      }
    }, [_vm._v(" " + _vm._s(product.catalogueCode) + " - " + _vm._s(product.name) + " ")]);
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      placeholder: _vm.$t("moq.enabled"),
      clearable: ""
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "enabled", $$v);
      },
      expression: "listQuery.enabled"
    }
  }, _vm._l(_vm.enableTypeOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.value,
        value: item.key
      }
    });
  }), 1), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "info",
      size: "mini",
      icon: "el-icon-search"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]), _c("router-link", {
    staticClass: "margin-horizontal",
    attrs: {
      to: "/moqs-discounts/add/" + _vm.moqId
    }
  }, [!_vm.isReadOnly ? _c("el-button", {
    staticClass: "filter-item",
    attrs: {
      type: "warning",
      size: "mini",
      icon: "el-icon-plus"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.add")) + " ")]) : _vm._e()], 1), !_vm.isReadOnly ? _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-document"
    },
    on: {
      click: _vm.handleExcelDownload
    }
  }, [_vm._v(" Export as Excel ")]) : _vm._e()], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": "",
      "span-method": _vm.doProductRowSpan
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "240px",
      label: "Product"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        var _scope$row$product;
        return [scope.row.product ? _c("span", [_vm._v(" " + _vm._s(((_scope$row$product = scope.row.product) === null || _scope$row$product === void 0 ? void 0 : _scope$row$product.name) || "") + " ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      align: "center",
      label: "Color",
      prop: "productsVariationId"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        var _scope$row$productsVa;
        return [_vm._v(" " + _vm._s(((_scope$row$productsVa = scope.row.productsVariation) === null || _scope$row$productsVa === void 0 ? void 0 : _scope$row$productsVa.name) || "") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "240px",
      label: "Range"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        var _scope$row$range;
        return [scope.row.product ? _c("span", [_vm._v(" " + _vm._s(((_scope$row$range = scope.row.range) === null || _scope$row$range === void 0 ? void 0 : _scope$row$range.name) || "") + " ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "110px",
      align: "center",
      label: "Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.isNewScheme ? _c("el-tag", {
          attrs: {
            type: scope.row.isPieces ? "warning" : "success",
            size: "mini"
          }
        }, [_vm._v(" " + _vm._s(scope.row.isPieces ? "Pieces" : "Carton") + " ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      align: "center",
      label: "Min. Qty (PCS)",
      prop: "minimumQuantity"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      align: "center",
      label: "Min. Carton Qty",
      prop: "minimumCartonQuantity"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      align: "center",
      label: "Discount (%)",
      prop: "discount"
    }
  }), _c("el-table-column", {
    attrs: {
      align: "center",
      label: "Actions",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/moqs-discounts/edit/" + scope.row.id
          }
        }, [!_vm.isReadOnly ? _c("el-button", {
          attrs: {
            type: "primary",
            size: "mini",
            icon: "el-icon-edit"
          }
        }) : _vm._e()], 1)];
      }
    }])
  })], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };